module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4y2NgGBTgnKDaf3LwIDLgP5kAbgCPTM9/cvAgMoDiMLAq1/hPDh5EBgxtAACpn1kWyG8UdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GM.png
// module id = 1150
// module chunks = 0